import { ArrowUpIcon } from '@heroicons/react/solid'
import React, { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import Context from '../context/context'
import { BillingSidebar } from './BillingSidebar'
import Content from './Content'
import DailyReportPopup from './DailyReportPopup'
import Header from './Header'
import HorizontalTabs from './HorizontalTabs'
import Info from './Info'
import ItemAvilibility from './ItemAvilibility'
import MealScheduling from './MealScheduling'
import VerticalTabs from './VerticalTabs'

const RightSide = ({ setIsItemAvilableOpen, isMealSchedulingOpen, setIsMealSchedulingOpen, isItemAvilableOpen, setIsDailyReportSummary, isDailyReportSummary, isOrdersTablePopUpOpen, setIsOrdersTablePopUpOpen }) => {

  const { pathname } = useLocation();
  const [isPaymentOptionOpen, setPaymentOptionOpen] = useState({ status: false, amount: 0 });
  const [runningOrder, setRunningOrder] = useState(null)

  const context = useContext(Context);
  const { setFlushData, setVideoPopUp, orderProps, setOrderProps } = context;

  useEffect(() => {
    isPaymentOptionOpen && sessionStorage.setItem('is-payment-popup', isPaymentOptionOpen.status);
  }, [isPaymentOptionOpen]);

  useEffect(() => {
    console.log(orderProps)
  }, [orderProps]);

  return (
    <div className="right-side">
      <Header />
      <HorizontalTabs />

      <div style={{ display: "flex", height: "100%" }}>
        {pathname.indexOf("/page2") === -1 ? <VerticalTabs /> : null}
        <Content
          runningOrder={runningOrder}
          setRunningOrder={setRunningOrder}
          setOrderProps={setOrderProps}
          setIsItemAvilableOpen={setIsItemAvilableOpen}
          isItemAvilableOpen={isItemAvilableOpen}
          setIsDailyReportSummary={setIsDailyReportSummary}
          isDailyReportSummary={isDailyReportSummary}
          isOrdersTablePopUpOpen={isOrdersTablePopUpOpen}
          setIsOrdersTablePopUpOpen={setIsOrdersTablePopUpOpen}
          isPaymentOptionOpen={isPaymentOptionOpen}
          setPaymentOptionOpen={setPaymentOptionOpen}
          isMealSchedulingOpen={isMealSchedulingOpen}
          setIsMealSchedulingOpen={setIsMealSchedulingOpen}
        />
        {pathname.indexOf("/page2") !== -1 && window.location.search.indexOf("edit") !== -1 ? (
          <BillingSidebar />
        ) : pathname.indexOf("/page2") === -1 && pathname.indexOf("edit") === -1 ? (
          <Info
            runningOrder={runningOrder}
            setRunningOrder={setRunningOrder}
            orderProps={orderProps}
            setOrderProps={setOrderProps}
            isPaymentOptionOpen={isPaymentOptionOpen}
            setPaymentOptionOpen={setPaymentOptionOpen}
            isOrdersTablePopUpOpen={isOrdersTablePopUpOpen}
            setIsOrdersTablePopUpOpen={setIsOrdersTablePopUpOpen}
          />
        ) : pathname.indexOf("/page2") !== -1 && pathname.indexOf("edit") === -1 ? (
          <Info
            runningOrder={runningOrder}
            setRunningOrder={setRunningOrder}
            orderProps={orderProps}
            setOrderProps={setOrderProps}
            isPaymentOptionOpen={isPaymentOptionOpen}
            setPaymentOptionOpen={setPaymentOptionOpen}
            quatityEditable
          />
        ) : ''}
      </div>

      {isMealSchedulingOpen && (
        <MealScheduling
          isMealSchedulingOpen={isMealSchedulingOpen}
          setIsMealSchedulingOpen={setIsMealSchedulingOpen}
        />
      )}

      {isItemAvilableOpen && (
        <ItemAvilibility
          isItemAvilableOpen={isItemAvilableOpen}
          setIsItemAvilableOpen={setIsItemAvilableOpen}
        />
      )}

      {isDailyReportSummary && (
        <DailyReportPopup
          setIsDailyReportSummary={setIsDailyReportSummary}
          isDailyReportSummary={isDailyReportSummary}
        />
      )}

      {+sessionStorage.getItem("flush") === 1 ?
        <div
          style={{
            position: "absolute",
            zIndex: "999",
            bottom: "10vh",
            left: "100px",
            backgroundColor: "red",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "200px",
            height: "50px",
            color: "white",
            borderRadius: "20px",
            fontSize: "15px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
          onClick={() => setFlushData(true)}
        >
          Flush Sample Data
        </div>
        : ""}
      {+sessionStorage.getItem("flush") === 1 ?
        <div
          style={{
            position: "absolute",
            zIndex: "999",
            bottom: "10vh",
            left: "45%",
            backgroundColor: "#4ac959",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "200px",
            height: "50px",
            color: "white",
            borderRadius: "20px",
            fontSize: "15px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
          onClick={() => setVideoPopUp(true)}
        >
          Tutorial Video (1min)<ArrowUpIcon style={{ width: "20px" }} />
        </div>
        : ""}
    </div>
  );
}

export default RightSide
